import Vue from 'vue'
import { createApp } from 'vue';
import App from '../components/ManufacturerProductsFilter.vue';
import 'vs-vue3-select/dist/vs-vue3-select.css';
import '@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css';
import '../styles/pagination.css'

createApp(App).mount('#app');